import React from 'react';
import { formatDate } from '../../utils/formatDate';

/**
 * Star rating display (1-5).
 */
function StarRating({ rating }) {
  if (!rating) return <span className="text-gray-500">-</span>;
  return (
    <span className="flex items-center gap-1" aria-label={`Ocena ${rating} na 5`}>
      {[1, 2, 3, 4, 5].map((i) => (
        <span
          key={i}
          className={`text-xl ${i <= rating ? 'text-yellow-400' : 'text-gray-300'}`}
          aria-hidden
        >
          ★
        </span>
      ))}
      <span className="ml-2 text-gray-700">({rating}/5)</span>
    </span>
  );
}

/**
 * Detail block: label (de-emphasized) + value (emphasized). Refactoring UI pattern.
 */
function DetailRow({ label, children }) {
  return (
    <div>
      <span className="block text-xs font-medium uppercase tracking-wide text-gray-500 mb-1">
        {label}
      </span>
      <div className="text-gray-900">{children}</div>
    </div>
  );
}

/**
 * Full review details panel (date, order, email, rating, text).
 */
function ReviewDetails({ review }) {
  if (!review) return null;

  const date = formatDate(review.createdAt || review.date);
  const email = review.clientEmail || review.email || '-';
  const orderNumber = review.orderNumber || '-';
  const rating = review.starRating ?? review.rating;
  const text =
    review.textReview || review.reviewText || review.comment || '-';

  return (
    <div className="mt-6 p-6 bg-gray-50 rounded-lg border border-gray-200">
      <h3 className="text-lg font-semibold text-gray-900 mb-4">Szczegóły opinii</h3>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <DetailRow label="Data dodania">{date}</DetailRow>
        <DetailRow label="Numer opinii">
          <span className="font-semibold">#{review.id}</span>
        </DetailRow>
        <DetailRow label="Numer zamówienia">{orderNumber}</DetailRow>
        <DetailRow label="Email">
          <span className="break-all">{email}</span>
        </DetailRow>
        <DetailRow label="Ocena">
          <StarRating rating={rating} />
        </DetailRow>
        <div className="md:col-span-2">
          <DetailRow label="Treść opinii">
            <p className="whitespace-pre-wrap bg-white p-3 rounded border border-gray-200 min-h-[80px]">
              {text}
            </p>
          </DetailRow>
        </div>
      </div>
    </div>
  );
}

export default ReviewDetails;
